import _ from 'lodash';
import error from 'aurora-utils/error';
import * as types from './constants';

const defaultState = {
  loading: false,
  layout: null,
  error,
  marekrData: null,
};

export default function homeLayoutReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.FETCH_HOME_LAYOUT:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_HOME_LAYOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        layout: _.get(action.payload, 'layout'),
        error,
      };
    case types.FETCH_HOME_LAYOUT_FAILURE:
      return {
        ...state,
        loading: false,
        layout: null,
        error: _.get(action.payload, 'error'),
      };
    case types.FETCH_MARKET_DATA:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_MARKET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        marekrData: _.get(action.payload, 'marekrData'),
        error,
      };
    case types.FETCH_MARKET_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        marekrData: null,
        error: _.get(action.payload, 'error'),
      };
    case types.FETCH_HOME_PAGE_DATA:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_HOME_PAGE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        homePageData: _.get(action.payload, 'homePageData'),
        error,
      };
    case types.FETCH_HOME_PAGE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        homePageData: [],
        error: _.get(action.payload, 'error'),
      };
    default:
      return state;
  }
}
